export const packageCruiseEnabled = (countryCode: string) => {
    return ['de'].includes(countryCode);
};
